// useMediaQuery — HF-2.3 Defense-in-Depth (Sprint 7+8 Hotfix).
//
// JS-side Breakpoint-Detection als Backup zu Tailwinds responsive
// `md:`/`xl:`-Klassen. Wird in BentoGrid verwendet, um die Tablet- und
// Desktop-Varianten conditional zu mounten — damit kann kein
// CSS-Cascade-Konflikt (z.B. inline-style display) je wieder zu Doppel-
// Render fuehren, weil nur EIN Wrapper im DOM landet.
//
// SSR-Verhalten: getSnapshot liefert vor Hydration `false`. Bei reinem
// Vite-SPA (kein SSR) wird useEffect sofort nach erstem Render
// ausgefuehrt — kein sichtbarer Flicker.

import { useEffect, useState } from "react";

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    // Initial sync (z.B. wenn der State noch vom getSnapshot kommt
    // bevor das mql-Object verfuegbar war).
    setMatches(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
